import { Component, input, OnInit, output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';


export interface ButtonToggleItem {
  name: string,
  value: string
}


@Component({
  selector: 'app-button-toggler',
  imports: [MatButtonToggleModule, ReactiveFormsModule],
  templateUrl: './button-toggler.component.html',
  styleUrl: './button-toggler.component.scss'
})
export class ButtonTogglerComponent implements OnInit {

  buttons = input.required<ButtonToggleItem[]>();

  default = input<string>('');

  selected = new FormControl<string>(this.default());

  setSelected = output<string | null>();

  ngOnInit(): void {

    this.selected.valueChanges.pipe(
    ).subscribe((selected) => {
      this.setSelected.emit(selected)
    })

    this.selected.setValue(this.default())
  }

}
